module.exports = __webpack_public_path__ + "static/img/portafolioSoftwareDigipagos.b3e72cb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/portfolioSoftware/portafolioSoftwareDigipagos.webp
// module id = 489
// module chunks = 1